export default "__VITE_ASSET__z$XQNwCY__"